import {
  isUndefinedNullOrEmpty,
  numberWithCommas,
} from "../../utils/common"
import {
  IncentiveType,
  AdditionalUserIncentives,
  IncentivesExpirationAfter,
  AdditionalCreditIncentiveType,
  DiscountPriceBasedOn,
  DiscountPriceApplicableOn,
  DiscountPriceExpirationAfter,
  AdditionalSubAccountIncentives,
  AddOnFeatureType,
  AdditionalContactIncentives,
} from "../../utils/enumUtil"

export class PromoApplySettings {
  promoCode;
  promoId;
  promoName;
  incentives;
  isShowPromoBox;
  isPromoApplied;
  incentiveDescriptions;
  errorMessage;
  constructor(data) {
    this.promoCode = (data && data.promoCode) || ""
    this.promoId = (data && data.promoId) || ""
    this.promoName = (data && data.promoName) || ""
    this.incentives = (data && data.incentives) || []
    this.isShowPromoBox = (data && data.isShowPromoBox) || false
    this.isPromoApplied = (data && data.isPromoApplied) || false
    this.incentiveDescriptions = (data && data.incentiveDescriptions) || []
    this.errorMessage = (data && data.errorMessage) || ""
  }
}

export class VerifyPromoResponse {
  isValidPromo
  invalidPromoReason
  invalidPromoDetail
  promoId
  promoCodeName
  isPurchaseAmountSet
  purchaseAmount
  promoIncentives
  errorMessage
  constructor(data) {
    this.isValidPromo = (data && data.isValidPromoCode) || false
    this.invalidPromoReason = (data && data.invalidPromoCodeReason) || ""
    //API-side detail beside the package reason (the reason enum ships in a NuGet package, so the
    //new "trial-only" answer rides on its own field; absent on an older API)
    this.invalidPromoDetail = (data && data.invalidPromoCodeDetail) || ""
    this.promoId = (data && data.promoCodeId) || ""
    this.promoCodeName = (data && data.promoCodeName) || ""
    this.purchaseAmount = (data && data.purchaseAmount) || 0
    this.isPurchaseAmountSet = (data && data.isPurchaseAmountSet) || false
    this.promoIncentives = (data && data.promoIncentiveList) || []
    this.errorMessage = VerifyPromoResponse.deserializedErrorMessage(
      this.invalidPromoReason,
      this.invalidPromoDetail
    )
  }

  //The API answers a promo it FOUND but will not apply (minimum purchase / subscription amount,
  //billing frequency, agency or plan restriction) with the promo id set and IsValidPromoCode false.
  //Only five reasons used to map to a message; the rest came back as "" and PricingMain took the
  //id-without-error as APPLIED with no incentives, which printed "the selected plan is better" and
  //left the promo's free units in the selection as paid add-ons (owner, 2026-09-18: a review-profile
  //promo rejected after a switch to Monthly). Any reason other than None is a rejection.
  static deserializedErrorMessage(failureReason, failureDetail = "") {
    if (!failureReason || failureReason === InvalidPromoCodeReason.None) return ""
    //Every incentive on the promo is for free trials only and this is a paid signup (owner, 2026-09-25)
    if (failureDetail === InvalidPromoCodeDetail.PromotionValidForTrialOnly)
      return "This promo code is for free trials only."
    return "The promotion is invalid. No discount or enhancement will be applied."
  }
}

export class IncentiveSummaryForPromoApplicable {
  type
  description
  expirationDescription
  expirationMonths
  savingLabel
  savingAmount

  constructor(data) {
    this.type = (data && data.type) || ""
    this.description = (data && data.description) || ""
    this.expirationDescription = (data && data.expirationDescription) || ""
    this.expirationMonths = (data && data.expirationMonths) || 0
    this.savingLabel = (data && data.savingLabel) || ""
    this.savingAmount = (data && data.savingAmount) || 0
  }
}

//INVALIDA PROMO CODE REASON
const InvalidPromoCodeReason = {
  None: "None",
  PromotionNotFound: "PromotionNotFound",
  PlanNotFound: "PlanNotFound",
  PromotionInvalidWithBeginingDate: "PromotionInvalidWithBeginingDate",
  PromotionInvalidWithEndDate: "PromotionInvalidWithEndDate",
  PromotionInvalidWithUserLimit: "PromotionInvalidWithUserLimit",
  PromotionInvalidWithSubscriptionAmount:
    "PromotionInvalidWithSubscriptionAmount",
  PromotionInvalidWithPurchaseAmount: "PromotionInvalidWithPurchaseAmount",
  PromotionInvalidWithBillingFrequency: "PromotionInvalidWithBillingFrequency",
  PromotionInvalidWithSelectedPlan: "PromotionInvalidWithSelectedPlan",
  AgencyNotFound: "AgencyNotFound",
  PromoInvalidWithAgecy: "PromoInvalidWithAgecy",
}

//INVALID PROMO CODE DETAIL (API-side, beside the reason)
const InvalidPromoCodeDetail = {
  None: "None",
  PromotionValidForTrialOnly: "PromotionValidForTrialOnly",
}